"use client";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import style from "@/styles/Popup.module.scss";
import Link from "next/link";
import ResponsiveSwiper from "@/Components/ResponsiveSwiper";
import { usePathname } from "next/navigation";
import CloudflareCaptcha from "@/Components/CloudflareCaptcha";
import { getCookie, setCookie } from "@/Snnipets/helper";

import FloatingField from "@/Ui_Elements/FloatingField/FloatingField";
import { getValidationSchema } from "@/lib/validationSchemas.js";
import { CommonSubmitForm } from "@/lib/CommonSubmitForm";
import { yupResolver } from "@hookform/resolvers/yup";

const Popup = () => {
  const validationSchema = getValidationSchema(4);
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue,
    clearErrors,
    reset,
    setError, // <-- added
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  const [isValidNum, setIsValidNum] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaKey, setCaptchaKey] = useState(0);

  // Cloudflare captcha callback
  const handleVerify = (token) => {
    setCaptchaToken(token || null);

    if (token) {
      setValue("captcha", token, {
        shouldValidate: true,
        shouldDirty: true,
      });
      clearErrors("captcha");
    } else {
      setValue("captcha", null);
    }
  };

  const resetCaptcha = () => {
    setCaptchaToken(null);
    clearErrors("captcha");

    // 🔥 Force remount Turnstile
    setCaptchaKey((k) => k + 1);
  };

  // Phone input change callback (from your FloatingField / intl input)
  const onPhoneChange = (isValid, rawValue) => {
    const containsOnlyNumbers = /^\d+$/.test(rawValue);

    if (containsOnlyNumbers || !rawValue) {
      setIsValidNum(isValid);
      setPhoneNumber(rawValue);
      setValue("mobile", rawValue, { shouldValidate: true });
    }
  };

  // Final submit handler
  const onSubmit = async (data, e) => {
    const isValidForm = await trigger();
    // check captcha
    if (!captchaToken) {
      setError("captcha", { type: "manual", message: "Captcha verification failed" });
      return;
    }
    if (isValidForm && isValidNum && captchaToken) {
      const res = await CommonSubmitForm(4, data);
      if (res.success) {
        reset();
        setPhoneNumber("");
        setValue("captcha", null);
        resetCaptcha();
      }
    }
  };

  const pathname = usePathname();
  const [isShown, setIsShown] = useState(false);
  const showModal = () => {
    setIsShown(true);
    document.body.classList.add("overflowhidden");
  };

  const closeModal = () => {
    setIsShown(false);
    document.body.classList.remove("overflowhidden");
    document.body.classList.remove("overflowhidden");
  };

  useEffect(() => {
    if (!getCookie("vlmspopupModal")) {
      const timer = setTimeout(() => {
        if (!["/contact-us", "/become-a-vidyalaya-partner", "/ebook"].includes(pathname)) {
          showModal();
          setCookie("vlmspopupModal", true, 8);
        }
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [pathname]);

  return (
    isShown && (
      // return (
      <>
        <section className={`${style["popup"]}`}>
          <div className={`${style["overlay-div"]}`} onClick={closeModal}></div>
          <div className={`container ${style["serviceform"]}`}>
            <div className={`custom-row ${style["backgroudimg"]}`}>
              <div className={style["leftpart"]}>
                <div className={`${style["paddingbox"]}`}>
                  <div className={`${style["popup-h2div"]}`}>
                    <h2 className={`${style["popuph2"]}`}>Let's Navigate Digital Transformation Together!!!</h2>
                    <div className={`${style["below-line"]}`}></div>

                    <div className={`${style["review-mainmaundiv"]} ${style["review-mainmaundivmb"]}`}>
                      <div className={`${style["review-main"]}`}>
                        <div className={`${style["review-badgessection"]}`}>
                          <img className={`${style["review-imagessection"]} img-fluid`} src="/images/vidyalaya_popup/a1.png" alt="client" />
                          <div></div>
                        </div>
                        <div className={`${style["review-badgessection"]}`}>
                          <img className={`${style["review-imagessection"]} img-fluid`} src="/images/vidyalaya_popup/a2.png" alt="client" />
                          <div></div>
                        </div>
                        <div className={`${style["review-badgessection"]}`}>
                          <img className={`${style["review-imagessection"]} img-fluid`} src="/images/vidyalaya_popup/a3.png" alt="client" />
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${style["fordesktop"]}`}>
                    <div className={`${style["visiblediv"]}`}>
                      <div className={`${style["review-main"]}`}>
                        <div className={`${style["review-badges"]} ${style["review-badges-withlink"]}`}>
                          <Link className={`${style["review-atag"]}`} target="_blank" href={"https://www.softwaresuggest.com/vidyalaya"}>
                            <img className={`${style["review-images"]} img-fluid`} src="/images/vidyalaya_popup/r1.png" alt="client" />

                            <p className={`${style["popup-review-para"]}`}>486 Reviews</p>
                          </Link>
                        </div>
                        <div className={`${style["review-badges"]} ${style["review-badges-withlink"]}`}>
                          <Link className={`${style["review-atag"]}`} target="_blank" href={"https://www.capterra.com/p/142375/Vidyalaya/#reviews"}>
                            <img className={`${style["review-images"]} img-fluid`} src="/images/vidyalaya_popup/r3.png" alt="client" />

                            <p className={`${style["popup-review-para"]}`}>38 Reviews</p>
                          </Link>
                        </div>
                        <div className={`${style["review-badges"]} ${style["review-badges-withlink"]}`}>
                          <Link className={`${style["review-atag"]}`} target="_blank" href={"https://www.goodfirms.co/software/vidyalaya"}>
                            <img className={`${style["review-images"]} img-fluid`} src="/images/vidyalaya_popup/r2.png" alt="client" />

                            <p className={`${style["popup-review-para"]}`}>250 Reviews</p>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className={`${style["visiblediv"]} ${style["onlycentervisiblediv"]}`}>
                      <div className={`${style["review-main"]}`}>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>23+</h4>
                            <h5 className={`${style["count-text"]}`}>Years Legacy</h5>
                          </div>
                        </div>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>1800+</h4>
                            <h5 className={`${style["count-text"]}`}>Clientele</h5>
                          </div>
                        </div>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>1.5 Millions</h4>
                            <h5 className={`${style["count-text"]}`}>Student</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`${style["visiblediv"]}`}>
                      <div className={`${style["review-main"]}`}>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>40+</h4>
                            <h5 className={`${style["count-text"]}`}>Modules</h5>
                          </div>
                        </div>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>96%</h4>
                            <h5 className={`${style["count-text"]}`}>Clients Retention</h5>
                          </div>
                        </div>
                        <div className={`${style["review-badges"]}`}>
                          <div className={`${style["fornew_purpose"]}`}>
                            <h4 className={`${style["count-h4"]}`}>25000+</h4>
                            <h5 className={`${style["count-text"]}`}>Professional Trained</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={style["rightpart"]}>
                <div className={`${style["form-card"]} form-card`}>
                  <div className={`${style["form-card-inner"]} form-card-inner"`}>
                    <h5 className={`${style["cardhead"]} cardhead`}>Contact With Our Experts</h5>

                    <form id="contact_form_popup" className="commonform" onSubmit={handleSubmit(onSubmit)} autoComplete="on">
                      <div className={style["input-box"]}>
                        <FloatingField
                          id="name_popup"
                          type="text"
                          label="Your Name"
                          placeholder="Your Name"
                          name="name"
                          register={register}
                          error={errors.name}
                          setValue={setValue}
                          isFloatedLabel={false}
                        />
                      </div>

                      <div className={style["input-box"]}>
                        <FloatingField
                          id="email_popup"
                          type="email"
                          label="Your Email"
                          placeholder="Enter your email"
                          name="email"
                          register={register}
                          error={errors.email}
                          setValue={setValue}
                          isFloatedLabel={false}
                        />
                      </div>
                      <div className={style["input-box"]}>
                        <FloatingField
                          id="mobile_popup"
                          type="intl"
                          label="Phone no."
                          placeholder="Phone no."
                          name="mobile"
                          register={register}
                          phoneNumber={phoneNumber}
                          isValidNum={isValidNum}
                          onPhoneNumberChange={onPhoneChange}
                          error={errors.mobile}
                          setValue={setValue}
                          isFloatedLabel={false}
                        />
                      </div>

                      <div className={style["input-box"]}>
                        <FloatingField
                          id="organization_popup"
                          type="text"
                          label="Institute"
                          placeholder="Institute Name"
                          name="organization"
                          register={register}
                          error={errors.organization}
                          setValue={setValue}
                          isFloatedLabel={false}
                        />
                      </div>
                      <div className={`${style["popup-submit"]}`}>
                        <div className={`${style["inputgroup"]} inputgroup`}>
                          <div className={`${style["popup-captcha"]} popup-recaptcha c-recaptcha`}>
                            <CloudflareCaptcha onVerify={handleVerify} key={captchaKey} />
                            {errors.captcha && <div className={`${style["error"]} captcha-error`}>{errors.captcha.message}</div>}
                            <input
                              type="hidden"
                              {...register("captcha", {
                                required: "Captcha verification failed",
                              })}
                            />
                          </div>
                        </div>
                        <div className={`text-center ${style["example"]}`}>
                          <button type="submit" className={`${style["btn"]} btn ${style["send-btn"]} commonformbtn`}>
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className={`${style["displaydiv"]} ${style["displaymobilediv"]} ${style["counterdiv"]}`}>
                <div className={`${style["review-main"]}`}>
                  <ResponsiveSwiper
                    swiperConfig={{
                      spaceBetween: 20,
                      centerSlide: false,
                      loop: true,
                      slidesPerView: "auto",
                      breakpoints: {
                        320: { slidesPerView: 1 },
                        425: { slidesPerView: 2 },
                        576: { slidesPerView: 3 },
                      },
                      autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                      },
                      navigation: false,

                      className: "commonswiperclass",
                    }}
                  >
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>23+</h4>
                      <h5 className={`${style["count-text"]}`}>Years mobile Legacy</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>1800+</h4>
                      <h5 className={`${style["count-text"]}`}>Clientele</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>1.5 Millions</h4>
                      <h5 className={`${style["count-text"]}`}>Student</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>40+</h4>
                      <h5 className={`${style["count-text"]}`}>Modules</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>96%</h4>
                      <h5 className={`${style["count-text"]}`}>Clients Retention</h5>
                    </div>
                    <div className={`${style["review-badges"]}`}>
                      <h4 className={`${style["count-h4"]}`}>25000+</h4>
                      <h5 className={`${style["count-text"]}`}>Professional Trained</h5>
                    </div>
                  </ResponsiveSwiper>
                </div>
                {/* <div className={`${style["visiblediv"]}`}>
                    <div className={`${style["review-main"]}`}></div>
                  </div> */}
              </div>

              <div className={`${style["client-div"]}`}>
                <ResponsiveSwiper
                  swiperConfig={{
                    spaceBetween: 20,
                    loop: true,
                    slidesPerView: "auto",
                    breakpoints: {
                      320: { slidesPerView: 3 },
                      576: { slidesPerView: 4 },
                    },
                    autoplay: {
                      delay: 3000,
                      disableOnInteraction: false,
                    },
                    navigation: false,

                    className: "commonswiperclass",
                  }}
                >
                  <div className={`${style["clients"]} ${style["clientsfirst"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/1.png" alt="client" />
                  </div>
                  {/* <div className={`${style["clients"]}`}>
                  {" "}
                  <img
                    className={`${style["clientimg"]}`}
                    src="/images/vidyalaya_popup/2.png"
                    alt="client"
                  />
                </div> */}
                  <div className={`${style["clients"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/3.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsvedanata"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/4.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/5.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/11.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsvedanata"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/6.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsholcim"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/7.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/8.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/10.png" alt="client" />
                  </div>
                  <div className={`${style["clients"]} ${style["clientsreddy"]}`}>
                    {" "}
                    <img className={`${style["clientimg"]}`} src="/images/vidyalaya_popup/9.png" alt="client" />
                  </div>
                </ResponsiveSwiper>
              </div>
            </div>
            <div id="closebtn" className={`${style["closediv"]}`} onClick={closeModal}>
              <span className={`${style["closespan"]}`}>&#10006;</span>
            </div>
          </div>
        </section>
      </>
    )
  );
};

export default Popup;
